import type { BrandInsightsPageContext, Chat } from '@trinity/chat';
import { ChatContextType } from '@trinity/chat';
import { generateEmptyChatSessionFiltersState } from '@trinity/chat-components/components/Chat.State/state.initial-state';

export function calculateIfFiltersActive(data: CalculateActiveCount) {
  return calculateActiveFiltersCount(data) > 0;
}

export function calculateActiveFiltersCount({ context, data, features }: CalculateActiveCount) {

  let count = data.custom.length;
  const defaults = generateEmptyChatSessionFiltersState({ context, features });

  count += countStandardFilterDiffs(data, defaults, context);
  count += countEngagementFilter(data, features, context);

  return count;
}

function sortedById(items: { id: string }[] | undefined | null) {
  return JSON.stringify((items || []).concat().sort((a, b) => a.id.localeCompare(b.id)));
}

function countStandardFilterDiffs(data: Chat.Filters, defaults: Chat.Filters, context: BrandInsightsPageContext.Item): number {
  let count = 0;
  if (sortedById(data.sources) != sortedById(defaults.sources)) count++;
  if (data.minDocumentDate != defaults.minDocumentDate) count++;
  if (data.tags.length) count++;
  if (sortedById(data.dataSources) != sortedById(defaults.dataSources)) count++;
  if (data.records?.length && context.type === ChatContextType.Global) {
    count += data.records.length;
  }
  if (data.projects.length) count++;
  return count;
}

function countEngagementFilter(data: Chat.Filters, features: CalculateActiveCount['features'], context: BrandInsightsPageContext.Item): number {
  if (features.engagementFilter && data.engagement?.id !== 'all' && [
    ChatContextType.Global,
    ChatContextType.KolProfile,
  ].includes(context.type)) {
    return 1;
  }
  return 0;
}

type CalculateActiveCount = {
  context: BrandInsightsPageContext.Item;
  data: Chat.Filters;
  features: {
    hcpProfiles: boolean;
    workspaces: boolean;
    engagementFilter: boolean;
  }
};
